import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

export const GetSignatureTemplates = CreateProcess({
	method: "GET",
	name: "GetSignatureTemplates",
	type: "SIGNATURETEMPLATES:GET",

	request: () => ({
		url: "/api/signature-templates/",
	}),

	success: (response) => fromJS(response.data),
});

export const GetSignatureTemplate = CreateProcess({
	method: "GET",
	name: "GetSignatureTemplate",
	type: "SIGNATURETEMPLATES:GETONE",

	request: (props) => ({
		url: `/api/signature-templates/${props.templateID}/`,
	}),

	success: (response) => ({
		id: response.data.id,
		data: fromJS(response.data),
	}),
});
